import { CalculatorHeadline, PreCalculatorHeadline } from "src/components/Calculator/CalculatorTypography";

import { CalculatorLayout } from "src/components/Calculator/CalculatorLayout";
import GeschwindigkeitCalculator from "src/components/Calculator/geschwindigkeitRechner";
import React from "react";
import SeoHead from "src/components/Seo/SeoHead";
import useTranslation from "next-translate/useTranslation";

const GeschwindigkeitsPage = () => {
  const { t, lang } = useTranslation("geschwindigkeitRechner");

  return (
    <CalculatorLayout
      header={
        <div data-test="page-rechner-geschwindigkeitsrechner">
          <PreCalculatorHeadline>{t("subHeadlineText1")}</PreCalculatorHeadline>
          <CalculatorHeadline>{t("headlineText1")}</CalculatorHeadline>
        </div>
      }
    >
      <SeoHead
        title={t("metaTitle")}
        description={t("metaDescription")}
        ogTitle={t("openGraphTitle")}
        ogDescription={t("openGraphDescription")}
        ogImage={"/images/calculators/geschwindigkeit-rechner/The-Cycleverse-OpenGraph-Geschwindigkeitsrechner.png"}
      />
      <GeschwindigkeitCalculator />
    </CalculatorLayout>
  );
};

export default GeschwindigkeitsPage;
